/**
 * Auth Module
 */
import Vue from "vue";
// import firebase from 'firebase/app'
import Nprogress from "nprogress";
import router from "../../../router";
import { userRoles } from "../../../constants/constants";
import {
	facebookAuthProvider,
	googleAuthProvider,
	twitterAuthProvider,
	githubAuthProvider,
} from "../../../firebase";
import api from "../../../api/apibackend.js";
import {
	TOKEN_VALUE,
	USER_DATA,
	TOKEN_TYPE,
	STORE_DATA,
} from "../../../commons/constants";
import {
	API_SIGNUP,
	API_LOGOUT,
	API_LOGIN,
	SIGNUP_CLIENT,
	REQUEST_RECOVERY_PASSWORD,
	CHECK_TOKEN_RECOVERY,
	CHANGES_PASSWORD,
} from "./actions.types";
import {
	SET_LOGIN,
	LOGIN_API_SUCCESS,
	LOGIN_API_FAILURE,
	SET_USER_AUTH,
	SIGNUP_START,
	SIGNUP_END,
	SIGNUP_SUCCESS,
} from "./mutations.types";
import { SET_STORE } from "../storeModule/mutations.type";
import { GET_STORE_USER_AUTH } from "../storeModule/actions.type";

const state = {
	user: null,
	isUserSigninWithAuth0: Boolean(localStorage.getItem("isUserSigninWithAuth0")),
	token: localStorage.getItem(TOKEN_VALUE) || "",
	tokenType: "Bearer",
	isAuthenticated: false,
};

// getters
const getters = {
	getUser: (state) => {
		return state.user || JSON.parse(localStorage.getItem(USER_DATA));
	},
	isUserSigninWithAuth0: (state) => {
		return state.isUserSigninWithAuth0;
	},
	isAuthenticated: (state) => state.isAuthenticated,
	getToken: (state) => {
		return state.token;
	},
};

// actions
const actions = {
	async [API_LOGIN]({ commit, dispatch }, { email, password }) {
		try {
			commit("loginUser");
			const config = {
				headers: { "Content-Type": "application/json; charset=utf-8" },
			};

			const res = await api.post("auth/login", { email, password }, config);
			commit(LOGIN_API_SUCCESS, res.data);
			console.log(commit, res.data, state);
			if (state.user.role_id === userRoles.CLIENT) {
				const resStore = await api.get(`store/mystore`);
				commit(SET_STORE, resStore.data);
			}
		} catch (err) {
			commit(LOGIN_API_FAILURE, err);
		}
	},
	[API_SIGNUP](context, payload) {
		const { user } = payload;
		api
			.post("admin", user)
			.then((res) => {
				return Promise.resolve(true);
			})
			.catch((err) => {
				context.commit(LOGIN_API_FAILURE, err);
				return Promise.reject(false);
			});
	},
	[API_LOGOUT](context) {
		Nprogress.start();
		api
			.get("auth/logout")
			.then((res) => {
				context.commit(SET_LOGIN);
				context.commit(SET_STORE, null);
			})
			.catch((err) => {
				context.commit(SET_LOGIN);
			});
	},
	async [SIGNUP_CLIENT]({ commit }, client) {
		try {
			commit(SIGNUP_START);
			const { data } = await api.post("auth/signup", client);
			commit(SIGNUP_END);
			commit(SIGNUP_SUCCESS, data);

			// if (state.user.role_id === userRoles.DELIVERY)
			// 	router.push("/delivery-profile");

			// if (state.user.role_id === userRoles.TICKETMASTER) router.push("/events");
			// else router.push("/dashboard");
			router.push("/success")
			return data;
		} catch (error) {
			commit(SIGNUP_END);

			let messageError = "❌ Error de conexión";
			messageError = error.response.data.errors.email
				? "❌ El email ya esta registrado"
				: "❌ Los datos ingresados son inválidos";

			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: messageError,
			});
		}
	},
	async [REQUEST_RECOVERY_PASSWORD]({ commit }, email) {
		try {
			Nprogress.start();
			const { data } = await api.get(`auth/recover/${email}`);
			Nprogress.done();
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Email enviado exitosamente",
			});
			return data;
		} catch (err) {
			Nprogress.done();
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.response
					? "❌ No existe ningun usuario registrado con este email"
					: "❌ Error de conexión",
			});
		}
	},
	async [CHANGES_PASSWORD]({ commit }, auth) {
		try {
			const { data } = await api.post(`auth/resetpassword/${auth.code}`, auth);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Contraseña actualizada exitosamente",
			});
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: "❌ Ha ocurrido un error al cambiar la contraseña",
			});
		}
	},
};

// mutations
const mutations = {
	[SIGNUP_START](state) {
		Nprogress.start();
	},
	[SIGNUP_END](state) {
		Nprogress.done();
	},
	[SIGNUP_SUCCESS](state, payload) {
		let {
			access_token,
			name,
			lastname,
			email,
			token_type,
			role_id,
			user_id,
			store_id,
		} = payload;
		let user = {
			name,
			lastname,
			email,
			role_id,
			user_id,
			store_id,
		};
		state.user = user;
		state.isAuthenticated = true;
		localStorage.setItem(TOKEN_VALUE, access_token);
		localStorage.setItem(TOKEN_TYPE, token_type);
		localStorage.setItem(USER_DATA, JSON.stringify(payload));
	},
	loginUser(state) {
		Nprogress.start();
	},
	loginUserSuccess(state, user) {
		state.user = user;
		localStorage.setItem("user", JSON.stringify(user));
		state.isUserSigninWithAuth0 = false;
		router.push("/dashboard");
		/*setTimeout(function() {
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: 'User Logged In Success!'
      })
    }, 1500)*/
	},
	loginUserFailure(state, error) {
		Nprogress.done();
		Vue.notify({
			group: "loggedIn",
			type: "error",
			text: error.message,
		});
	},
	logoutUser(state) {
		state.user = null;
		localStorage.removeItem("user");
		router.push("/session/login");
	},
	signUpUser(state) {
		Nprogress.start();
	},
	signUpUserSuccess(state, user) {
		state.user = localStorage.setItem("user", user);
		router.push("/dashboard");
		Vue.notify({
			group: "loggedIn",
			type: "success",
			text: "✔️ Cuenta creada satisfactoriamente",
		});
	},
	signUpUserFailure(state, error) {
		Nprogress.done();
		Vue.notify({
			group: "loggedIn",
			type: "error",
			text: error.message,
		});
	},
	signInUserWithAuth0Success(state, user) {
		state.user = user;
		localStorage.setItem("user", JSON.stringify(user));
		state.isUserSigninWithAuth0 = true;
	},
	signOutUserFromAuth0Success(state) {
		state.user = null;
		localStorage.removeItem("user");
	},
	[LOGIN_API_SUCCESS](state, payload) {
		const {
			access_token,
			plan_id,
			name,
			lastname,
			email,
			token_type,
			role_id,
			user_id,
			store_id,
		} = payload;
		console.log(payload);
		let user = {
			plan_id,
			name,
			lastname,
			email,
			role_id,
			user_id,
			store_id,
		};

		localStorage.setItem(TOKEN_VALUE, access_token);
		localStorage.setItem(TOKEN_TYPE, token_type);
		localStorage.setItem(USER_DATA, JSON.stringify(payload));
		state.user = user;
		state.isAuthenticated = true;
    
		switch (role_id) {
			case userRoles.DELIVERY: {
				router.push("/delivery-profile");
				return;
			}
			case userRoles.CASHIER: {
				router.push("/shopping-list");
				return;
			}
			case userRoles.TICKETMASTER: {
				router.push("/ticket-sales/pending");
				return;
			}
			default: {
				router.push("/store");
			}
		}

		Nprogress.done();
	},
	[LOGIN_API_FAILURE](state, error) {
		console.log(error);
		Vue.notify({
			group: "loggedIn",
			type: "error",
			text: error.response
				? "❌ Los datos ingresados son inválidos"
				: "❌ Error de conexión",
		});
		Nprogress.done();
	},
	[SET_LOGIN](state) {
		localStorage.removeItem(TOKEN_VALUE);
		localStorage.removeItem(USER_DATA);
		localStorage.removeItem(TOKEN_TYPE);
		localStorage.removeItem(USER_DATA);
		localStorage.removeItem(STORE_DATA);
		state.user = null;
		state.isAuthenticated = false;
		router.push("/session/login");
		Nprogress.done();
	},
	[SET_USER_AUTH](state, user) {
		state.user = user;
		localStorage.setItem(USER_DATA, JSON.stringify(user));
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
